<template>
    <div class="app-block bg-alabaster border border-alto shadow zone-etape" v-if="!displayOffers">
        <div v-if="!statusSelected && !situationSelected">
            <div style="text-align: center"><h3 class="titre-etape">Sélectionnez <b>votre statut</b></h3></div>

            <div class="row row-center">
                <div v-for="(stat, index) in status" class="form-group col-12 col-md-auto text-center" >
                    <span v-if="(index !== 'mil' && index !== 'cvd')" class="app-badge app-badge-bordered" v-on:click="validEtap1(index);validEtap2(defaultSituation);">
                        {{ stat }}
                    </span>
                    <span v-else class="app-badge app-badge-bordered" v-on:click="validEtap1(index)">
                        {{ stat }}
                    </span>
                </div>
            </div>

        </div>
        <div v-if="statusSelected && !situationSelected">
            <div style="text-align: center"><h3 class="titre-etape">Sélectionnez <b>votre situation géographique</b></h3></div>
            <div class="row row-center">
                <div v-for="(situation, index) in situations" class="form-group col-12 col-md-auto text-center" >
                    <span  class="app-badge app-badge-bordered" v-on:click="validEtap2(index)">
                        {{ situation }}
                    </span>
                </div>
            </div>
        </div>
    </div>
    <div v-else >
        <div style="text-align: center"><h3 class="titre-etape pt-3">Vos offres <b>santé</b></h3></div>
        <div class="app-wrapper mb-2 my-mb-4">
            <div class="container-fluid">
                <div class="row" v-if="offers.length > 1">
                    <offre-component v-for="(offer, index) in offers" :offre="offer" :key="index"></offre-component>
                </div>
            </div>
        </div>
        <div class="etape-recap" v-if="offers.length > 1">
            <b>Votre statut :</b>
            {{ status[statusSelected] }}<br>
            <div v-if="(statusSelected === 'mil' || statusSelected === 'cvd')">
                <b>Votre situation géographique :</b>
                {{ situations[situationSelected] }} <br>
            </div>
            <br><button v-on:click="change" class="btn btn-primary mt-4">Modifier mes critères</button>
        </div>
    </div>
</template>

<script>
import OffreComponent from "./OffreComponent";
export default {
    name: "EtapesComponent",
    components: {OffreComponent},
    data() {
        return {
            status: {
                "mil": "Militaire",
                "gen": "Gendarme",
                "cvd": "Civil de la défense",
                "pol": "Police Nationale",
                "pom": "Pompier pro",
                "res": "Réserviste",
                "civ": "Civil",
                "retMil": "Retraité militaire",
                "retCiv": "Retraité civil"
            },
            statusSelected: null,
            situations: {
                "fra": "Résident en France",
                "etr": "Résident à l'étranger"
            },
            situationSelected: null,
            defaultSituation : 'fra',
            displayOffers: false,
            offers: null
        }
    },
    methods: {
        clearSelection() {
            this.offers = null
            this.statusSelected = null
            this.situationSelected = null
        },
        validEtap1(value) {
            this.statusSelected = value
        },
        validEtap2(value) {
            this.situationSelected = value;
            this.getOffers()
        },
        getOffers() {
            axios.get('/api-sante', {
                params: {
                    status: this.statusSelected,
                    situation: this.situationSelected
                }
            }).then(response => {
                this.offers = response.data
                var offers_list = this.offers;
                console.log('MES DONNEES', offers_list[0].url);
                this.displayOffers = true
                if(offers_list.length < 2){
                    console.log('TEST DATA');
                    window.location.href = offers_list[0].url;
                }
            }).catch(error=> {
                console.log(error)
            });
        },
        change() {
            this.clearSelection()
            this.displayOffers = false
            window.scrollTo(0, 0)
        }
    }

}
</script>

<style scoped>

</style>
